import React, { PureComponent } from 'react';
import { Row, Col } from 'react-bootstrap';
import SectionsSortable from './sectionsList/sectionsSortable';

class SectionsList extends PureComponent {
  render() {
    const {
      items,
      onChangeSectionsList,
      showModalHandle,
      addLink,
    } = this.props;

    return (
      <div>
        <div className="group-new-section">
          <h1 className="main-title">Sections</h1>
          <div className="edit-link">
            <span
              onClick={addLink}
              className="new-link-btn"
            >
              Add Section
            </span>
          </div>
        </div>
        <Row>
          <Col sm={12}>
            {items.length
              ? <SectionsSortable
                sectionsList={items}
                onChangeSectionsList={onChangeSectionsList}
                showModalHandle={showModalHandle}
              />
              : <Row className="section-row">
                <Col sm={12}>
                  <p>
                    No sections found.
                  </p>
                </Col>
              </Row>
            }
        </Col>
        </Row>
      </div>
    );
  }
}

export default SectionsList;


// WEBPACK FOOTER //
// ./src/app/screens/sections/sectionsList.js